/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-18 15:20:33
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-19 11:23:02
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/LineCollapse/index.tsx
 */
import React from 'react';

import css from './css.less';

import { AntdCollapse } from 'src/components/Antd';
import LineHeader from './Components/LineHeader';

interface IItem {
  headerText: string | JSX.Element;
  key: string;
  content: JSX.Element;
  headerProps?: { [propsName: string]: any };
  hideStatusText?: boolean;
}

const LineCollapse = (props) => {
  const { data, open, setOpen } = props;

  const collapseData = data.map((i: IItem) => {
    const { headerText, key, content, headerProps, hideStatusText } = i;
    return {
      header: (
        <LineHeader
          open={open.includes(key)}
          header={headerText}
          hideStatusText={hideStatusText}
        />
      ),
      content: content,
      key,
      headerProps,
    };
  });
  return (
    <AntdCollapse
      data={collapseData}
      open={open}
      setOpen={setOpen}
      generalPanelClassName={css.panelItemClassName}
    />
  );
};

export default LineCollapse;
